import CSS from "csstype";
import React from "react";
import { StateProps } from "./Center";
import { getLatestTurnDisplay } from "./turnDisplay";

type LeftTurnSignalProps = StateProps & {
  hideSignal: boolean;
};

export const LeftTurnSignal: React.FC<LeftTurnSignalProps> = ({ state, hideSignal }) => {
  if (hideSignal) {
    return null;
  }

  if (state.position === 1 && state.turn === 0 && state.landlordHandID === null) {
    return (
      <div style={leftTurnSignal}>
        <span>{state.shownCard.value}</span>
      </div>
    );
  }

  const latestTurn = getLatestTurnDisplay(state);
  if (latestTurn?.actor !== "left") {
    return null;
  }

  return (
    <div style={leftTurnSignal}>
      <span>{latestTurn.action === "pass" ? "pass" : "\u2192"}</span>
    </div>
  );
};

const leftTurnSignal: CSS.Properties = {
  position: "absolute",
  top: "50%",
  left: "25%",
  transform: "translateX(-50%)",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "1.5em",
};
